function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import Button from "segments/desktop/core-components/button/button";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { XS } from "components/core/new-button/button-component";
import { isDarkTheme } from "segments/segments-service";
import { StyledMondayDemoTimeline, StyledTimelineTabIndicationLabelAndProgressBarWrapper } from "./monday-demo-timeline.scss";
const MondayDemoTimeline = (props)=>{
    const { tabs, selectedTab, buttonConfig, buttonHighlighted, wasComponentEverVisible, onTabClick, videoDuration, theme } = props;
    const getButtonProps = ()=>{
        switch(buttonConfig.buttonType){
            case SIGNUP_BUTTON_TYPE:
                return _object_spread_props(_object_spread({}, buttonConfig), {
                    buttonSize: XS,
                    invert: !buttonHighlighted
                });
            default:
                return buttonConfig;
        }
    };
    return /*#__PURE__*/ _jsxs(StyledMondayDemoTimeline, {
        className: classnames("monday-demo-tabs-timeline-and-labels-wrapper", {
            "dark-theme": isDarkTheme(theme)
        }),
        role: "tablist",
        children: [
            tabs.map((tab, index)=>{
                const isSelected = index === selectedTab;
                return /*#__PURE__*/ _jsxs(StyledTimelineTabIndicationLabelAndProgressBarWrapper, {
                    className: classnames("timeline-tab-indication-label-and-progress-bar-wrapper", {
                        selected: isSelected && wasComponentEverVisible && !buttonHighlighted,
                        watched: index < selectedTab || buttonHighlighted
                    }),
                    onClick: (e)=>onTabClick({
                            index
                        }),
                    animationDuration: index <= selectedTab ? `${videoDuration}s` : `unset`,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "timeline-tab-indication-and-label-wrapper",
                            onKeyDown: generateOnKeyDownHandler((e)=>onTabClick({
                                    index
                                })),
                            role: "tab",
                            "aria-selected": isSelected,
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "timeline-tab-indication",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "timeline-tab-indication-outer-circle",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "timeline-tab-indication-inner-circle"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "timeline-tab-label",
                                    children: tab.tabLabel
                                })
                            ]
                        }),
                        index < tabs.length - 1 && /*#__PURE__*/ _jsx("div", {
                            className: "timeline-progress-bar-wrapper",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "timeline-progress-bar",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "timeline-progress-bar-empty"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "timeline-progress-bar-filled"
                                    })
                                ]
                            })
                        })
                    ]
                }, index);
            }),
            buttonConfig && /*#__PURE__*/ _jsx("div", {
                className: classnames("button-wrapper"),
                children: /*#__PURE__*/ _jsx(Button, _object_spread({}, getButtonProps()))
            })
        ]
    });
};
export default MondayDemoTimeline;
